import { ChatBubbleBottomCenterIcon, HeartIcon, XMarkIcon } from "@heroicons/react/24/outline";

import { Badge } from "@fronterahealth/frontera-ui-components";

import { type GetCommunityPostsOutput } from "@api/rest/types-and-hooks";
import { GripHandle } from "@components/GripHandle/GripHandle";

interface PostRowProps {
  post: GetCommunityPostsOutput;
  accentColor?: string;
  dragHandleProps?: Record<string, unknown>;
  showDragHandle?: boolean;
  onRemove: () => void;
}

export const PostRow: React.FC<PostRowProps> = ({
  post,
  accentColor,
  dragHandleProps,
  showDragHandle = true,
  onRemove,
}) => (
  <div className="flex items-center gap-x-2 px-3 py-2 rounded-lg bg-bg-default group">
    {accentColor && <div className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: accentColor }} />}
    {showDragHandle && (
      <button
        {...dragHandleProps}
        onClick={(e) => e.stopPropagation()}
        className="text-text-tertiary shrink-0 cursor-grab active:cursor-grabbing touch-none"
        aria-label="Drag to reorder"
      >
        <GripHandle />
      </button>
    )}
    <div className="flex-1 flex items-center gap-x-1 min-w-0">
      <span className="text-sm font-medium text-text-primary truncate">{post.name}</span>
      <span className="text-sm text-text-tertiary shrink-0">· {post.user_name}</span>
    </div>
    <div className="flex items-center gap-x-1 shrink-0 text-text-tertiary">
      <ChatBubbleBottomCenterIcon className="h-3.5 w-3.5" />
      <span className="text-xs">{post.comment_count}</span>
    </div>
    <div className="flex items-center gap-x-1 shrink-0 text-text-tertiary">
      <HeartIcon className="h-3.5 w-3.5" />
      <span className="text-xs">{post.like_count}</span>
    </div>
    <Badge text={post.space_name} appearance="neutral" className="bg-limestone-300" />
    <button
      onClick={onRemove}
      className="text-icon-tertiary hover:text-icon-primary transition-colors cursor-pointer"
      aria-label="Remove post"
    >
      <XMarkIcon className="h-4 w-4" />
    </button>
  </div>
);
